const state = {
    //showSettings: showSettings,
    fixedHeader: false, // Whether fix the header
    sidebarLogo: false // Whether show the logo in sidebar
}

const mutations = {
    CHANGE_SETTING: (state, { key, value }) => {
        // eslint-disable-next-line no-prototype-builtins
        if (state.hasOwnProperty(key)) {
            state[key] = value
        }
    }
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}